import { Pipe, PipeTransform } from '@angular/core';
import { User } from '@wilson/interfaces';
import { isNonAccessibleUser, NonAccessibleUser } from './types';

@Pipe({
  name: 'isNonAccessibleViewer',
  standalone: true,
})
export class IsNonAccessibleViewerPipe implements PipeTransform {
  transform(viewer: User | NonAccessibleUser): viewer is NonAccessibleUser {
    return isNonAccessibleUser(viewer);
  }
}
